import { createFileRoute } from "@tanstack/react-router";

import { AdminGuard } from "@/components/admin/AdminGuard";
import { AdminUsersPage } from "@/components/admin/AdminUsersPage";

export const Route = createFileRoute("/admin/users/new")({
  component: AdminUsersNewRoute,
});

function AdminUsersNewRoute() {
  return (
    <AdminGuard>
      <AdminUsersPage openCreate />
    </AdminGuard>
  );
}
